import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { LookupService } from '../services/lookup/lookup.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { Lookup } from '../app.types';
import { filter, shareReplay, switchMap, takeUntil } from 'rxjs/operators';
import { HttpResponse, HttpResponseBase } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponentDialog, createDefaultData } from '../confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'lookup-form',
    templateUrl: './lookup-form.component.html',
    styleUrls: ['./lookup-form.component.scss'],
    standalone: false
})
export class LookupFormComponent implements AfterViewInit, OnDestroy {
  @Input() lookupName: string = null;
  @Input() listTitle: string = null;
  @Input() controllerName: string = null;
  @Output() sendCloseEvent = new EventEmitter<string>();
  @Output() sendDeleteEvent = new EventEmitter<void>();

  resultsLength: number;
  
  data: Lookup[] = [];

  newValue = ''; 
  newValueID: string = null;
  
  public get showSearchBar() : boolean {
    return this.resultsLength > 9;
  }

  unSubscribe$ = new Subject();
  tableRefresh$ = new BehaviorSubject<void>(undefined);
  searchInput$ = new BehaviorSubject<string>(null);
  
  constructor(private lookupService: LookupService, 
      private toastrService: ToastrService,
      public dialog: MatDialog) {
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next(null);
    this.unSubscribe$.complete();
  }

  ngAfterViewInit(): void {
      combineLatest([
        this.tableRefresh$.pipe(
          switchMap(() => this.lookupService.getList(this.controllerName, { orderBy: 'name' })),
          shareReplay(1)
        ),
        this.searchInput$
      ]).pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(([result, searchTerm]) => {
        this.resultsLength = result.totalNumberOfRecords;
        
        this.data = result.results;

        if(searchTerm){
          this.data = this.data.filter(x => 
            x.name.toLowerCase().includes(searchTerm.toLowerCase()));
        }
      });
  }
  
  addNew(){
    this.lookupService.addNew(this.controllerName, {name: this.newValue})
      .subscribe(x => {
        if(x instanceof HttpResponse && x.ok){
          this.toastrService.success(`${this.lookupName} added successfully`);
          this.newValueID = x.body.id;
          this.tableRefresh$.next(null);
        }
      });
  }
  
  delete(event: MouseEvent, lookup: Lookup){
    event.stopPropagation();

    const dialogRef = this.dialog.open(ConfirmDialogComponentDialog, {
      data: createDefaultData(`Are you sure you want to delete the lookup ${lookup.name}?`)
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      if (result == null) {return;}

      if (result == false) {console.log("don't delete asset type");}

      if (result == true){
        this.lookupService.delete(this.controllerName, lookup)
          .pipe(filter(x => (x instanceof HttpResponseBase)))
          .subscribe(x => {
            if(x instanceof HttpResponse && x.ok){
              this.toastrService.success(`${this.lookupName} deleted successfully`);
              this.tableRefresh$.next(null);
              this.sendDeleteEvent.emit();
            }
        });
      }
    });
    
  }

  searchTermChanged(event){
    this.searchInput$.next(event.target.value);
  }

  selectItem(lookup: Lookup) {
    this.sendCloseEvent.emit(lookup.id);
  }

  closeForm() {
    this.sendCloseEvent.emit(null);
  }
}
